import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-小程序用户",
  "use": "icon-小程序用户-usage",
  "viewBox": "0 0 21 22.10546875",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 21 22.10546875\" id=\"icon-小程序用户\"><g><g><ellipse cx=\"6.6315789222717285\" cy=\"6.6315789222717285\" rx=\"6.6315789222717285\" ry=\"6.6315789222717285\" fill=\"#00DE9B\" fill-opacity=\"1\" /></g><g style=\"mix-blend-mode:multiply\"><ellipse cx=\"13.263157844543457\" cy=\"14.368421077728271\" rx=\"7.736842155456543\" ry=\"7.736842155456543\" fill=\"#3BD0FF\" fill-opacity=\"1\" style=\"mix-blend-mode:multiply\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/小程序用户.svg
// module id = T2HO
// module chunks = 119